import type { SelectItem } from '@nuxt/ui'

const rawFaixasRenda = [
    'Até 1 salário mínimo',
    'De 1 a 3 salários mínimos',
    'De 3 a 6 salários mínimos',
    'De 6 a 9 salários mínimos',
    'De 9 a 12 salários mínimos',
    'De 12 a 15 salários mínimos',
    'Mais de 15 salários mínimos'
]

// Converte a lista simples de strings em um array tipado de objetos SelectItem
export const faixasRenda: SelectItem[] = rawFaixasRenda.map(faixa => ({
  label: faixa,
  value: faixa
}))